import Variant2 from '@/components/pages/partners/variant2';

const PartnerPage = () => {
  return <Variant2 />;
};

export default PartnerPage;
